import { DataTable } from './DataTable'
import { Button } from 'antd'
import { YhBox } from '@/components/YhBox'
import { threeInspectionFatigueDrivingModel } from '../fatigueDrivingModel'
import { ExportOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { exportListData } = threeInspectionFatigueDrivingModel()

    const action = (
        <>
            <Button style={{ marginBottom: '5px' }} shape="round" type="link" onClick={() => exportListData()}>
                <ExportOutlined />
                导出
            </Button>
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
